export default "__VITE_PUBLIC_ASSET__f98b7596__"